import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const SelectPlantPage = lazyWithRetry(
  () => import("@features/plantas/ui/pages/SelectPlantPage"),
  "SelectPlantPage",
);
const SelectMaintenancePage = lazyWithRetry(
  () => import("./ui/pages/SelectMaintenancePage"),
  "SelectMaintenancePage",
);
const CreateReportPage = lazyWithRetry(
  () => import("@features/reports/ui/pages/CreateReportPage"),
  "CreateReportPage",
);

/**
 * Rutas de mantenimiento
 */
const maintenanceRoutes = buildRoutes([
  // Selección de planta
  {
    path: "/mantenimiento",
    element: SelectPlantPage,
    roles: [1, 2, 3, 5],
  },

  // Ruta optimizada para selección de tipos de mantenimiento
  {
    path: "/mantenimiento/:planta/tipos-mantenimiento",
    element: SelectMaintenancePage,
    roles: [1, 2, 3, 5],
  },
  {
    path: "/mantenimiento/:planta/tipos-mantenimiento/:tipoMantenimiento",
    element: CreateReportPage,
    roles: [1, 2, 3, 5],
  },

  // Scan report
  {
    path: "/scan-report",
    element: CreateReportPage,
    roles: [1, 2, 3, 5],
  },
]);

export default maintenanceRoutes;
